/**
 * 加密工具函数
 *
 * 功能：
 * - MD5 加密
 */
import md5 from "js-md5";

/**
 * MD5 加密
 * @param str - 要加密的字符串
 * @returns MD5 哈希值（32位小写十六进制）
 */
export function md5Encrypt(str: string): string {
  return (md5 as any)(str);
}

/**
 * 密码 MD5 加密
 * 用于登录时加密密码
 * @param password - 原始密码
 * @returns MD5 加密后的密码
 */
export function encryptPassword(password: string): string {
  return md5Encrypt(password);
}
